import React from "react";
import { Col, Card, CardBody, Table, Row } from "reactstrap";
import PropTypes from 'prop-types';

//Simple bar
import SimpleBar from "simplebar-react";

//Import Images
import img1 from "../../assets/images/companies/img-1.png";
import img2 from "../../assets/images/companies/img-2.png";
import img3 from "../../assets/images/companies/img-3.png";
import { formatDate } from "helpers/backend_helper";
import { Link } from "react-router-dom";

const Notifications = (props) => {
  const reports = [
    {
      'type': 'Payslip',
      'link':'#'
    },
    {
      'type': 'RBS',
      'link':'#'
    },
    {
      'type': 'NSSF',
      'link':'#'
    },
    {
      'type': 'PAYE',
      'link':'#'
    }];

  return (
    <React.Fragment>
      <Col xl="12">
        <Card>
          <CardBody>
          <h4 className="card-title text-primary mdi mdi-clipboard-check-outline mb-4">{" "} Approvals</h4>
            <SimpleBar style={{ maxHeight: "370px" }}>
            <Link to="/approvals">
              
                
                {props.approvals && (props.approvals.length > 0) && (
                  
                  <div className="table">
                    <Table className="table table-sm m-0">
                      <thead>
                        <tr>
                          <th></th>
                          <th>Document No</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                      {props.approvals.map((a, k) => (
                        <tr key={k}>
                          <th scope="row">{k+1}</th>
                          <th><i className="mdi mdi-book-clock-outline me-1" /> {a.documentNo}</th>
                          <td>{formatDate(a.dateTimeSentforApproval)}</td>
                        </tr>
                      ))}
 
                      </tbody>
                    </Table>
                  </div>

                )}
                {props.approvals && (props.approvals.length < 1) && (
                  <ul className="list-group">
                  <li className="list-group-item border-0" >
                  <div className="d-flex">
                  <div className="flex-grow-1">
                      <h5 className="font-size-14">No Pending Approvals!</h5>
                  </div>
                  </div>
                </li>
                </ul>
                )}
               
              
              </Link>
             
            </SimpleBar>
          </CardBody>
        </Card>
        {(props.showReports == true) && (
        <Card className="bg-success bg-soft">
        <div>
          <Row>
            <Col xs="12">
              <div className="text-primary p-3">
                <h5 className="text-primary">Reports:</h5>

                <ul className="ps-3 mb-0">
                {reports && reports.map((l,k)=>(
                  <li className="py-1" key={k}><Link to="#">{l.type}</Link></li>
                ))}
                 
                </ul>
              </div>
            </Col>
          </Row>
        </div>
      </Card>
      )}
      </Col>
      
    </React.Fragment>
  );
};
Notifications.propTypes = {
  approvals: PropTypes.any,
  birthdays: PropTypes.any,
  showReports: PropTypes.any
};
export default Notifications;
